import React, { useMemo } from "react";
import styles from "./Offer.module.css";
import { NavLink } from "react-router-dom";
import PageLayout from "../../components/PageLayout/PageLayout";

const Offer: React.FC = () => {
  const path = useMemo(() => {
    const user = localStorage.getItem("user");
    return user ? "/addcompany" : "/signin";
  }, []);

  return (
    <PageLayout className={styles.offerPage}>
      <section className={styles.container}>
        <div className={styles.hero}>
          <h1 className={styles.title}>Dodaj firmę do katalogu Cartena.pl</h1>
          <p className={styles.lead}>
            Wizytówka firmy w Cartena.pl jest bezpłatna bezterminowo.
            Na pierwsze 12 miesięcy otrzymujesz pakiet Rozszerzony GRATIS
            (logo i 1 zdjęcie). Po tym czasie, bez przedłużenia, firma pozostaje
            w katalogu w pakiecie Darmowym. Dostępne są również kategorie Sklep i Serwis.
          </p>
        </div>

        <div className={styles.grid}>
          <NavLink to={path} className={`${styles.cardLink} ${styles.card} ${styles.cardFeatured}`}>
            <div className={styles.ribbon}>START</div>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>Rozszerzony na 12 miesięcy</h2>
              <span className={styles.badge}>GRATIS</span>
            </div>
            <p className={styles.cardDesc}>Pakiet Rozszerzony gratis na start. Po 12 miesiącach wizytówka pozostaje bezpłatna w pakiecie Darmowym.</p>
            <div className={styles.priceBox}>
              <div className={styles.priceRow}>
                <span className={styles.priceLabel}>Cena</span>
                <span className={styles.currentPrice}>0 PLN</span>
              </div>
            </div>
            <div className={styles.cardFooterRow}>
              <span className={styles.cta}>Dodaj firmę za darmo</span>
            </div>
          </NavLink>

          <NavLink to={path} className={`${styles.cardLink} ${styles.card}`}>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>2 lata</h2>
            </div>
            <p className={styles.cardDesc}>
              Pakiet Rozszerzony na 2 lata. Po zakończeniu okresu wizytówka pozostaje w bezpłatnym pakiecie Darmowym.
            </p>
            <div className={styles.priceBox}>
              <div className={styles.priceRow}>
                <span className={styles.priceLabel}>Cena</span>
                <span className={styles.currentPrice}>49 PLN netto</span>
              </div>
            </div>
            <div className={styles.cardFooterRow}>
              <span className={styles.cta}>Wybierz 2 lata</span>
            </div>
          </NavLink>

          <NavLink to={path} className={`${styles.cardLink} ${styles.card}`}>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>3 lata</h2>
            </div>
            <p className={styles.cardDesc}>
              Pakiet Rozszerzony na 3 lata. Po zakończeniu okresu wizytówka pozostaje w bezpłatnym pakiecie Darmowym.
            </p>
            <div className={styles.priceBox}>
              <div className={styles.priceRow}>
                <span className={styles.priceLabel}>Cena</span>
                <span className={styles.currentPrice}>69 PLN netto</span>
              </div>
            </div>
            <div className={styles.cardFooterRow}>
              <span className={styles.cta}>Wybierz 3 lata</span>
            </div>
          </NavLink>
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoTitle}>Co zawierają pakiety wizytówki?</div>
          <div className={styles.infoText}>
            <strong>Darmowy:</strong> podstawowe dane firmy i opis usług, bez publicznego
            wyświetlania logo i zdjęć.
            <ul>
              <li><strong>Rozszerzony:</strong> logo firmy i 1 zdjęcie.</li>
              <li><strong>Wyróżniony:</strong> logo firmy i 3 zdjęcia, wyższa pozycja w wynikach.</li>
              <li><strong>Polecane TOP 3:</strong> logo firmy i 5 zdjęć, korzyści Wyróżnienia oraz miejsce w TOP 3 wybranej kategorii i województwa.</li>
            </ul>
            Możesz dodać do 5 zdjęć w panelu firmy. Liczba zdjęć widocznych
            publicznie zależy od aktywnego pakietu.
          </div>
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoTitle}>Porównanie pakietów — co jest dostępne?</div>
          <div className={styles.infoText}>
            <div className={styles.tableScroll}>
              <table className={styles.packageTable}>
                <thead>
                  <tr>
                    {[
                      "Funkcja", "Darmowy", "Rozszerzony", "Wyróżniony", "Polecane TOP 3",
                    ].map((heading) => (
                      <th key={heading} scope="col">
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Wizytówka i dane kontaktowe", "✓", "✓", "✓", "✓"],
                    ["Opis firmy i usług", "✓", "✓", "✓", "✓"],
                    ["Obecność w katalogu", "✓", "✓", "✓", "✓"],
                    [
                      "Priorytet wyświetlania w wynikach",
                      "Standardowy",
                      "Podwyższony",
                      "Wysoki",
                      "Najwyższy",
                    ],
                    ["Logo firmy", "—", "✓", "✓", "✓"],
                    ["Zdjęcia widoczne publicznie", "0", "1", "3", "5"],
                    ["Wyróżnienie w wynikach", "—", "—", "✓", "✓"],
                    ["Specjalne oznaczenie oferty", "—", "—", "✓", "✓"],
                    ["Gwarantowane TOP 3 w wybranej kategorii i województwie", "—", "—", "—", "✓"],
                    ["Szarfa POLECANE", "—", "—", "—", "✓"],
                  ].map((cells) => (
                    <tr key={cells[0]}>
                      {cells.map((cell, column) => (
                        <td key={column}>
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
              <p className={styles.tableNote}>
                <strong>Kolejność wyświetlania firm:</strong>{" "}
                Polecane TOP 3 → Wyróżnione → Rozszerzone → Darmowe.
                Wyższy pakiet zapewnia wyższy priorytet w wynikach,
                ale nie gwarantuje konkretnej pozycji.
                Wyjątkiem jest pakiet Polecane TOP 3, który gwarantuje
                miejsce w pierwszej trójce wybranej kategorii i województwa.
                <br />
                <br />
                ✓ — dostępne, — — niedostępne. W panelu firmy można
                przechowywać do 5 zdjęć; ich publiczna widoczność
                zależy od aktywnego pakietu.
              </p>
          </div>
        </div>

        <div className={styles.grid}>
          <div className={styles.card}>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>⭐ Wyróżnienie</h2>
            </div>
            <p className={styles.cardDesc}>
              Lepsza widoczność firmy w katalogu, logo i galeria do 3 zdjęć.
            </p>
            <div className={styles.priceBox}>
              <div className={styles.priceRow}>
                <span className={styles.priceLabel}>Cena</span>
                <span className={styles.currentPrice}>
                  +150 PLN netto za każdy rozpoczęty rok
                </span>
              </div>
              <ul>
                <li>Wyższa pozycja w wynikach</li>
                <li>Logo firmy i do 3 widocznych zdjęć</li>
                <li>Specjalne oznaczenie oferty</li>
              </ul>
            </div>
          </div>

          <div className={`${styles.card} ${styles.cardFeatured}`}>
            <div className={styles.ribbon}>TOP 3</div>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>🚀 Polecane</h2>
            </div>
            <p className={styles.cardDesc}>
              Najwyższy pakiet promocji. Zawiera korzyści Wyróżnienia oraz
              miejsce w TOP 3 w wybranej kategorii i województwie.
            </p>
            <div className={styles.priceBox}>
              <div className={styles.priceRow}>
                <span className={styles.priceLabel}>Cena</span>
                <span className={styles.currentPrice}>
                  +300 PLN netto za każdy rozpoczęty rok
                </span>
              </div>
              <ul>
                <li>Tylko 3 miejsca w kategorii i województwie</li>
                <li>Logo firmy i do 5 widocznych zdjęć</li>
                <li>Zawiera Wyróżnienie</li>
                <li>Szarfa „POLECANE” na wizytówce</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoTitle}>Jak działa publikacja i promocja?</div>
          <div className={styles.infoText}>
            Publikacja wizytówki w pakiecie Darmowym jest zawsze bezpłatna.
            Nowa firma otrzymuje pakiet Rozszerzony na pierwsze 12 miesięcy gratis.
            Można wybrać dłuższy okres pakietu Rozszerzonego (2 lub 3 lata)
            oraz dodatkowe opcje promowania firmy zgodnie z cennikiem.
            Po wygaśnięciu pakietu lub promocji, bez przedłużenia, wizytówka
            pozostaje w katalogu w pakiecie Darmowym. Nie naliczamy automatycznie opłat.
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Offer;
